import { gql } from "@apollo/client"
import { useQuery } from "@oysterhr/core"
import { MONEY_FIELDS } from "~/shared/fragments/MoneyFields"
import { Engagement } from "@oysterhr/schema"

const CUSTOMER_TEAM_MEMBER_ENROLLMENTS = gql`
  ${MONEY_FIELDS}
  query CustomerTeamMemberEnrollments($engagementId: ID!) {
    engagement(engagementId: $engagementId) {
      id
      company {
        id
        authorizations {
          actions
        }
      }
      benefitsEnrollments {
        collection {
          id
          state
          coverageStartDate
          enrolledAt
          availableEvents
          totalPrice {
            ...MoneyFields
          }
          totalPriceInvoicedCompany {
            ...MoneyFields
          }
          currentPrice {
            tmInvoicedContribution {
              ...MoneyFields
            }
          }
          plan {
            name
            copy
            logoUrl
            category
            guideUrl
            externalLink
            provider {
              name
            }
          }
          dependents {
            collection {
              id
            }
          }
          engagement {
            id
            isPayrollTeamMember
            dependents {
              collection {
                id
                fieldsWithValues
              }
              metadata {
                totalCount
              }
            }
          }
          authorizations {
            actions
          }
        }
      }
    }
  }
`

export function useCustomerTeamMemberEnrollments(engagementId: string) {
  return useQuery<{ engagement: Engagement }>(CUSTOMER_TEAM_MEMBER_ENROLLMENTS, {
    variables: {
      engagementId,
    },
    fetchPolicy: "cache-and-network",
    notifyOnNetworkStatusChange: true,
  })
}
